export default function(patient) {
  if (!patient) return '';
  return [patient.givenName, patient.familyName].filter(v => v).join(' ');
}
